import React from 'react';
import FeatureModels from '../../../../models/Feature';
import { CheckboxContained, CheckboxContainedGroup } from '@homeexchange/design';
import i18n from '../../../../i18n';
export var Accessibility = function (_a) {
    var onUpdate = _a.onUpdate, values = _a.values;
    var getLabel = function (feature) {
        return i18n.t("home:".concat(feature.featureName));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(CheckboxContainedGroup, { collapsible: false }, FeatureModels.FEATURES.filter(function (feature) { return feature.category === FeatureModels.RULE || feature.icon === 'disabled-access'; }).map(function (feature) { return (React.createElement(CheckboxContained, { name: 'amenities', type: "checkbox", key: "amenities-".concat(feature.icon), label: React.createElement(React.Fragment, null, i18n.t(getLabel(feature))), onChange: onUpdate, value: feature.icon, icon: feature.icon, checked: values && values.includes(feature.icon), id: "gtm-track-".concat(feature.icon) })); }))));
};
export default Accessibility;
